/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface WebAuthnCreateChallenge
 */
export interface WebAuthnCreateChallenge {
    /**
     * 
     * @type {string}
     * @memberof WebAuthnCreateChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof WebAuthnCreateChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof WebAuthnCreateChallenge
     */
    authentication_method: FactorMethod;
    /**
     * The "Options for Credential Creation" as described by the WebAuthn spec at https://www.w3.org/TR/webauthn/#dictionary-makecredentialoptions
     * @type {object}
     * @memberof WebAuthnCreateChallenge
     */
    options?: object;
}

/**
 * Check if a given object implements the WebAuthnCreateChallenge interface.
 */
export function instanceOfWebAuthnCreateChallenge(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "authentication_method" in value;

    return isInstance;
}

export function WebAuthnCreateChallengeFromJSON(json: any): WebAuthnCreateChallenge {
    return WebAuthnCreateChallengeFromJSONTyped(json, false);
}

export function WebAuthnCreateChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebAuthnCreateChallenge {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': !exists(json, 'options') ? undefined : json['options'],
    };
}

export function WebAuthnCreateChallengeToJSON(value?: WebAuthnCreateChallenge | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': ChallengeTypeToJSON(value.type),
        'authentication_method': FactorMethodToJSON(value.authentication_method),
        'options': value.options,
    };
}

